const getReleaseVersion = () => {
  const releaseVersion = process.env.REACT_APP_RELEASE_VERSION;
  const commitSha = process.env.REACT_APP_COMMIT_SHA1_SHORT;

  if (releaseVersion && commitSha) {
    return `${releaseVersion}+${commitSha}`;
  }

  return releaseVersion || commitSha || 'development';
};

const config = () => {
  const environments = {
    development: {
      environment: 'development',
      apiServer: 'https://api.dev.spotlightnews.us',
      apiEventServer: 'https://event-api.dev.spotlightnews.us',
      newsServer: 'https://news.dev.spotlightnews.us',
      appServer: 'https://my.dev.spotlightnews.us',
      sentryDSN: null,
      version: getReleaseVersion(),
      tokenKey: 'dev-my.spotlightnews.us-token',
      messagesKey: 'dev-my.spotlightnews.us-messages',
      tokenKeyDelete: 'dev-my.spotlightnews.us-delete-account-token',
      stripePk: 'pk_test_hhERP5OpsuaF9MhgIQny0N74',
      mixpanelToken: 'a35a8be36fab405f9bb96cf1e04d6fdc',
    },
    staging: {
      environment: 'staging',
      apiServer: 'https://api.stg.spotlightnews.us',
      apiEventServer: 'https://event-api.stg.spotlightnews.us',
      newsServer: 'https://news.stg.spotlightnews.us',
      appServer: 'https://my.stg.spotlightnews.us',
      sentryDSN: null,
      version: getReleaseVersion(),
      tokenKey: 'stg-my.spotlightnews.us-token',
      messagesKey: 'stg-my.spotlightnews.us-messages',
      tokenKeyDelete: 'stg-my.spotlightnews.us-delete-account-token',
      stripePk: 'pk_test_hhERP5OpsuaF9MhgIQny0N74',
      mixpanelToken: 'a35a8be36fab405f9bb96cf1e04d6fdc',
    },
    publisher: {
      environment: 'staging',
      apiServer: 'https://api.pbl.spotlightnews.us',
      apiEventServer: 'https://event-api.prd.spotlightnews.us',
      newsServer: 'https://news.pbl.spotlightnews.us',
      appServer: 'https://my.pbl.spotlightnews.us',
      sentryDSN: null,
      version: getReleaseVersion(),
      tokenKey: 'pbl-my.spotlightnews.us-token',
      messagesKey: 'pbl-my.spotlightnews.us-messages',
      tokenKeyDelete: 'pbl-my.spotlightnews.us-delete-account-token',
      stripePk: 'pk_test_hhERP5OpsuaF9MhgIQny0N74',
      mixpanelToken: 'a35a8be36fab405f9bb96cf1e04d6fdc',
    },
    production: {
      environment: 'production',
      apiServer: 'https://api.spotlightnews.us',
      apiEventServer: 'https://event-api.spotlightnews.us',
      newsServer: 'https://news.spotlightnews.us',
      appServer: 'https://my.spotlightnews.us',
      sentryDSN: 'https://f2d17adc064f44928221ff18ba2caceb@sentry.io/1536597',
      version: getReleaseVersion(),
      tokenKey: 'my.spotlightnews.us-token',
      messagesKey: 'my.spotlightnews.us-messages',
      tokenKeyDelete: 'my.spotlightnews.us-delete-account-token',
      stripePk: 'pk_live_r6qpAgrVOuqwQJiMR8hP6a8o',
      mixpanelToken: '64a5e2ef1a58ef7676fa7ad5d5e5309e',
    },
  };

  switch (window.location.origin) {
    case 'https://my.spotlightnews.us': {
      return environments.production;
    }
    case 'https://my.stg.spotlightnews.us': {
      return environments.staging;
    }
    case 'https://my.pbl.spotlightnews.us': {
      return environments.publisher;
    }
    default: {
      return environments.development;
    }
  }
};

export default config();
